module.exports = __webpack_public_path__ + "static/media/country_eg.3e1d1e04.webp";